import axios from "axios";
import { useEffect, useState } from "react";
import {
  MdHomeFilled,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import Pagination from "react-js-pagination";
import { Link, Routes, Route, useParams, useNavigate } from "react-router-dom";
import Committeegnb from "./Committeegnb";
import ConfirmModal from "../../components/ConfirmModal";
function Committeeprocess3() {
  let navigate = useNavigate();
  const { id } = useParams();
  const [commPostData, setCommPostData] = useState([]);
  const [page, setPage] = useState(1);
  const [filterType, setFilterType] = useState("init");
  const [filterInput, setFilterInput] = useState("");
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [filterModal, setFilterModal] = useState(false);
  const [filterValidateModal, setFilterValidateModal] = useState(false);

  // 검색 필터 타입
  const onChangeFilterType = (e) => {
    setFilterType(e.target.value);
  };
  const onChangeFilterInput = (e) => {
    setFilterInput(e.target.value);
  };
  const onClickFilter = () => {
    // console.log(`onClick filterType = ${filterType}`);
    // console.log(`onClick filterInput = ${filterInput}`);
    if (filterType === "init") {
      // alert("검색필터를 선택하세요.");
      setFilterModal(true);
      setFilterInput("");
      getCommMemeberInfoData();
    } else if (filterType === "nameLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else {
      setPage(0);
      PageFilterReplace();
    }
  };
  const PageFilterReplace = () => {
    // console.log(`page = ${page}`);
    getCommMemeberInfoData();
  };
  const handlePageChange = (page) => {
    getCommMemeberInfoData(page);
    setPage(page);
  };
  const openModal = (e) => {
    e.preventDefault();
    setFilterModal(true);
  };
  const closeModal = (e) => {
    e.preventDefault();
    setFilterModal(false);
    setFilterValidateModal(false);
  };

  const getCommMemeberInfoData = async (pageNum) => {
    try {
      if (pageNum === undefined) pageNum = 1;
      let params = {
        pageNumber: pageNum,
        committeeTypeId: id,
        pageSize: 5,
        nameLike: filterInput,
      };
      const response = await axios.get(`/api/committee-member/`, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      setCommPostData(response.data.data);
      setRecords(response.data);
      setTotalItems(response.data.recordsFiltered);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCommMemeberInfoData();
  }, [id]);

  return (
    <>
      {filterModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색 필터"}
          content={`검색 필터를 선택해 주세요.`}
        />
      ) : null}
      {filterValidateModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색어 입력"}
          content={`검색어를 입력해 주세요.`}
        />
      ) : null}
      <Committeegnb />
      <div className="">
        <div className="">
          <form className="my_page bbs_contain">
            <div className="row_bbs bbs_customqa_wrap">
              <div className="search_box">
                <div className="select_box">
                  <select
                    name="all"
                    onChange={onChangeFilterType}
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      검색필터
                    </option>
                    <option value="nameLike">이름</option>
                  </select>
                </div>
                <div className="input_wrap">
                  <input
                    className="input_line"
                    type="search"
                    placeholder="검색어를 입력하세요."
                    value={filterInput}
                    onChange={onChangeFilterInput}
                  />
                  <button
                    className="btn_color"
                    type="button"
                    onClick={onClickFilter}
                  >
                    검색
                  </button>
                </div>
              </div>
              <table className="table_wrap_customerqa">
                <thead>
                  <tr>
                    <th>위원명</th>
                    <th>소속/회사</th>
                    <th>역할</th>
                    <th>이메일</th>
                  </tr>
                </thead>
                <tbody>
                  {commPostData.map((value) => {
                    return (
                      <tr key={value.id}>
                        <td className="num_bbs">{value.name}</td>
                        <td>
                          <p>{value.organization}</p>
                        </td>
                        <td>
                          <p className="auth">{value.position}</p>
                        </td>
                        <td className="date_bbs">{value.email}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {commPostData.length > 0 ? null : (
                <span style={{ textAlign: "center", marginTop: "10vh" }}>
                  등록된 목록이 없습니다
                </span>
              )}
              <div className="pagination_wrap">
                <div></div>
                <div className="pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={5}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                  />
                </div>
                <div>
                  <button
                    style={{ visibility: "hidden" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/breakdown/cits");
                    }}
                    className="list_btn"
                  >
                    {/* 목록 */}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Committeeprocess3;
